document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.wo-megamenu');
  if (!root) return;

  var overlay = root.querySelector('.wo-megamenu__overlay');
  var burger = root.querySelector('.wo-megamenu__burger');
  var navLinks = root.querySelectorAll('.wo-megamenu__nav-link');
  var drawers = root.querySelectorAll('.wo-megamenu__drawer');
  var closeButtons = root.querySelectorAll('.wo-megamenu__close');
  var drawerNavButtons = root.querySelectorAll('.wo-megamenu__drawer-nav button');

  function closeAll() {
    drawers.forEach(function (d) { d.classList.remove('is-active'); d.setAttribute('aria-hidden', 'true'); });
    navLinks.forEach(function (n) { n.classList.remove('is-active'); n.setAttribute('aria-expanded', 'false'); });
    root.classList.remove('is-open');
    document.body.classList.remove('wo-megamenu-lock');
  }

  function openDrawer(key) {
    closeAll();
    var target = root.querySelector('.wo-megamenu__drawer[data-drawer="' + key + '"]');
    if (!target) return;
    target.classList.add('is-active');
    target.setAttribute('aria-hidden', 'false');
    root.classList.add('is-open');
    document.body.classList.add('wo-megamenu-lock');
    navLinks.forEach(function (n) {
      if (n.getAttribute('data-drawer-target') === key) {
        n.classList.add('is-active');
        n.setAttribute('aria-expanded', 'true');
      }
    });
    var firstFocusable = target.querySelector('button, a');
    if (firstFocusable) firstFocusable.focus({ preventScroll: true });
  }

  navLinks.forEach(function (link) {
    var key = link.getAttribute('data-drawer-target');
    if (!key) return; // dropdown disabled for this item — let it navigate normally

    link.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = root.querySelector('.wo-megamenu__drawer[data-drawer="' + key + '"]').classList.contains('is-active');
      isOpen ? closeAll() : openDrawer(key);
    });
    // Note: hover-open removed on purpose — menu now opens on click only,
    // on every screen size (desktop, tablet, mobile).
  });

  if (burger) {
    burger.addEventListener('click', function () {
      var firstWithDrawer = null;
      for (var i = 0; i < navLinks.length; i++) {
        if (navLinks[i].getAttribute('data-drawer-target')) { firstWithDrawer = navLinks[i]; break; }
      }
      var firstKey = firstWithDrawer ? firstWithDrawer.getAttribute('data-drawer-target') : null;
      if (root.classList.contains('is-open')) {
        closeAll();
      } else if (firstKey) {
        openDrawer(firstKey);
      }
    });
  }

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', closeAll);
  });

  if (overlay) overlay.addEventListener('click', closeAll);

  // Safety net: clicking anywhere outside an open drawer (and outside the
  // nav/burger that opened it) closes the menu, even if the overlay
  // element itself doesn't catch the click for any reason.
  document.addEventListener('click', function (e) {
    if (!root.classList.contains('is-open')) return;
    var clickedInsideDrawer = e.target.closest('.wo-megamenu__drawer');
    var clickedNavTrigger = e.target.closest('.wo-megamenu__nav-link, .wo-megamenu__burger, .wo-megamenu__drawer-nav');
    if (!clickedInsideDrawer && !clickedNavTrigger) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  // In-drawer nav switching (MEN/WOMEN/JUNIORS repeated inside the open drawer)
  drawerNavButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer(btn.getAttribute('data-drawer-target'));
    });
  });

  // Juniors sub-tabs
  root.querySelectorAll('.wo-megamenu__subtabs').forEach(function (tabRow) {
    var tabs = tabRow.querySelectorAll('.wo-megamenu__subtab');
    var panelWrap = tabRow.closest('.wo-megamenu__drawer').querySelectorAll('.wo-megamenu__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-subtab-target');
        tabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        panelWrap.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-subtab-panel') === target);
        });
      });
    });
  });
});